<template>
  <div class="ui-upload-wrapper">
    <transition-group name="list" tag="div" class="file-wrapper">
      <FileItem
        v-for="(item, index) in uploadFileList"
        :key="`${item.key || item.mediaId}`"
        :fileIndex="index"
        :fileInfo="item"
        @updateFileList="handleUpdateFileList"
        @delFile="handleDelFile"
      />
      <UploadBtn
        @chooseFile="handleChooseFile"
        key="uploadBtn"
        :fileList="uploadFileList"
        :limitLength="limitLength"
        :multiple="multiple"
        :fileTypeAccept="fileTypeAccept"
        :fileSizeLimit="fileSizeLimit"
        :fileTypeLimit="fileTypeLimit"
        :errorTypeMsgTmp="errorTypeMsgTmp"
        :uploadFileType="uploadFileType"
        :beforeChooseFile="beforeChooseFile"
        v-show="showUploadBtn"
      />
    </transition-group>
  </div>
</template>

<script>
import UploadBtn from "./UploadBtn"
import FileItem from "./FileItem"

export default {
  name: "uiUploadWrapper",
  props: {
    fileList: {
      type: Array,
      default() {
        return []
      }
    },
    fileTypeLimit: {
      type: [Array, Object],
      default() {
        return {
          image: ["jpeg", "jpg", "png", "webp", "bmp", "raw"],
          video: ["mp4", "avi", "flv", "rmvb", "mov"]
        }
      }
    },
    fileSizeLimit: {
      type: [Number, String, Object],
      default: 10 * 1024 * 1024
    },
    multiple: {
      type: Boolean,
      default: true
    },
    fileTypeAccept: {
      type: Object,
      default() {
        return {
          image: "image/*",
          video: "video/*"
        }
      }
    },
    limitLength: {
      type: [Number, String],
      default: ""
    },
    uploadFileType: {
      type: Array,
      default() {
        return ["image", "video"]
      }
    },
    fileTypeMap: {
      type: Object,
      default() {
        return {
          image: "图片",
          video: "视频"
        }
      }
    },
    errorTypeMsgTmp: {
      type: Object,
      default() {
        return {
          image: "该项目简称不支持上传[fileTypeName]",
          video: "该项目简称不支持上传[fileTypeName]",
          default: "该项目简称不支持上传该文件"
        }
      }
    },
    beforeChooseFile: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      uploadFileList: []
    }
  },
  methods: {
    _updateFileList() {
      this.$emit("updateFileList", this.uploadFileList)
    },
    initUploadFileList() {
      this.uploadFileList = this.fileList.slice()
    },
    handleChooseFile(fileArr) {
      this.uploadFileList = [...this.uploadFileList, ...fileArr]
    },
    handleUpdateFileList({ fileIndex, fileInfo }) {
      this.uploadFileList.splice(fileIndex, 1, fileInfo)
    },
    handleDelFile({ fileIndex }) {
      this.uploadFileList.splice(fileIndex, 1)
    }
  },
  components: {
    UploadBtn,
    FileItem
  },
  computed: {
    isOverLimitLength() {
      if (this.limitLength) {
        return this.uploadFileList.length >= this.limitLength
      }
      return false
    },
    showUploadBtn() {
      return !this.isOverLimitLength && this.uploadFileType.length > 0
    }
  },
  watch: {
    fileList() {
      this.initUploadFileList()
    },
    uploadFileList() {
      this._updateFileList()
    }
  },
  created() {
    this.initUploadFileList()
  }
}
</script>

<style lang="scss" scoped>
.ui-upload-wrapper {
  display: flex;
}
.file-wrapper {
  display: inline-flex;
  flex-wrap: wrap;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-0.3rem);
}
</style>
